module.exports = __webpack_public_path__ + "img/shuffle.d87da676.svg";